import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import Keycloak from 'keycloak-js';
import keycloak from './keycloak';

interface KeycloakProviderProps {
  children: ReactNode;
}

interface KeycloakContextProps {
  keycloak: Keycloak;
  authenticated: boolean;
  logout: () => void;
}

const KeycloakContext = createContext<KeycloakContextProps | undefined>(undefined);

export const KeycloakProvider: React.FC<KeycloakProviderProps> = ({ children }) => {
  const [keycloakInitialized, setKeycloakInitialized] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const initKeycloak = async () => {
      try {
        const authenticated = await keycloak.init({ onLoad: 'login-required' })
        .then((auth)=>{
          console.log(keycloak)
          return auth;
        })
        // console.log("KeycloakProvider", authenticated, keycloak.idToken);
        setAuthenticated(authenticated);
        setKeycloakInitialized(true);
      } catch (err) {
        console.error('Keycloak initialization failed', err);
      }
    };

    if (!keycloakInitialized) {
      initKeycloak();
    }
  }, [keycloakInitialized]);

  const logout = () => {
    keycloak.logout();
  };

  if (!keycloakInitialized) {
    return <div>Loading...</div>;
  }

  return (
    <KeycloakContext.Provider value={{ keycloak, authenticated, logout }}>
      {children}
    </KeycloakContext.Provider>
  );
};

export const useKeycloak = (): KeycloakContextProps => {
  const context = useContext(KeycloakContext);
  if (!context) {
    throw new Error('useKeycloak must be used within a KeycloakProvider');
  }
  return context;
};
